import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const SummarySection = styled("div")(() => ({
  display: "flex",
  padding: "24px",
  flexDirection: "column",
  gap: "16px",
  backgroundColor: colors.white,
  borderRadius: "12px",

  "@media screen and (max-width: 435px)": {
    borderRadius: 0,
  },
}));

export const SummaryHeader = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
}));

export const SummaryTitle = styled("span")(() => ({
  color: colors.gray600,
  font: "700 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const SummaryText = styled("span")(() => ({
  color: colors.gray600,
  font: "400 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const InfoCard = styled("div")(
  ({ backgroundColor, borderColor }: { backgroundColor: string; borderColor: string }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    borderRadius: "8px",
    border: `1px solid ${borderColor}`,
    background: backgroundColor,
  })
);

export const InfoHeader = styled("div")(() => ({
  display: "flex",
  padding: "16px 12px 4px 12px",
  alignItems: "flex-start",
  gap: "12px",
  alignSelf: "stretch",
}));

export const InfoContent = styled("div")(() => ({
  display: "flex",
  padding: "12px",
  alignSelf: "stretch",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
}));

export const InfoTextContent = styled("div")(() => ({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignSelf: "stretch",
}));

export const InfoTitle = styled("span")(({ color }: { color: string }) => ({
  color,
  font: "600 14px Manrope",
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const InfoText = styled("span")(() => ({
  color: colors.gray600,
  font: "400 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const InfoTextValue = styled("span")(() => ({
  color: colors.gray600,
  font: "700 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));
